import React from "react";

export const adminMemberLoginColumns = () => [
  {
    key: "index",
    label: "S.No",
    width: "60px",
    sortable: false,
    render: (row, index, page, pageSize) => (page - 1) * pageSize + index + 1,
  },
  {
    key: "admin_id",
    label: "Staff",
    width: "180px",
    sortable: false,
    render: (row) => row.admin_id?.name || "N/A",
  },
  {
    key: "role",
    label: "Role",
    width: "120px",
    sortable: false,
    render: (row) => row.admin_id?.role || "N/A",
  },
  {
    key: "user_profile_id",
    label: "Profile ID",
    width: "110px",
    sortable: false,
    render: (row) => row.user_id?.profile_id || "N/A",
  },
  {
    key: "user_name",
    label: "Member",
    width: "160px",
    sortable: false,
    render: (row) => row.user_id?.name || "N/A",
  },
  {
    key: "login_time",
    label: "Login Time",
    width: "170px",
    sortable: false,
    render: (row) =>
      new Date(row.login_time).toLocaleString("en-IN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }),
  },
  {
    key: "previous_session_logout_time",
    label: "Previous Logout",
    width: "170px",
    sortable: false,
    render: (row) =>
      row.previous_session_logout_time
        ? new Date(row.previous_session_logout_time).toLocaleString("en-IN", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })
        : "-",
  },
  {
    key: "device_type",
    label: "Device",
    width: "100px",
    sortable: false,
    render: (row) => row.device_type || "Unknown",
  },
  {
    key: "browser",
    label: "Browser",
    width: "120px",
    sortable: false,
    render: (row) => row.browser || "N/A",
  },
  {
    key: "os",
    label: "OS",
    width: "120px",
    sortable: false,
    render: (row) => row.os || "N/A",
  },
  {
    key: "ip_address",
    label: "IP Address",
    width: "140px",
    sortable: false,
    render: (row) => row.ip_address || "N/A",
  },
];